import { useContext, useEffect, useMemo, useRef } from 'react';
import { FormContext, FormRefsContext, FormRulesContext, GetRuleNameContext, GetRuleRegexErrorContext, OnSubmitRefContext } from '../context';
import { useBaseI18n } from './i18n-hooks';
import { useAlert } from './alert-hooks';
export var useForm = function () { return useContext(FormContext); };
export var useFormRules = function () { return useContext(FormRulesContext); };
export var useFormRefs = function () { return useContext(FormRefsContext); };
export var useOnSubmitRef = function () { return useContext(OnSubmitRefContext); };
export var useGetRuleName = function () { return useContext(GetRuleNameContext); };
export var useGetRuleRegexError = function () { return useContext(GetRuleRegexErrorContext); };
export var useFieldProps = function (field) {
    var form = useForm();
    return useMemo(function () { return form.getFieldProps(field); }, [form, field]);
};
export var useTextFieldError = function (field) {
    var form = useForm();
    var formRules = useFormRules();
    var smallerThan = useMemo(function () {
        var _a, _b;
        return (_b = (_a = formRules[field]) === null || _a === void 0 ? void 0 : _a.smallerThan) !== null && _b !== void 0 ? _b : 0;
    }, [formRules, field]);
    var fieldError = useMemo(function () {
        var _a;
        return (form.touched[field] || ((_a = form.values[field]) === null || _a === void 0 ? void 0 : _a.length) > smallerThan) ? form.errors[field] : null;
    }, [field, form, smallerThan]);
    return fieldError;
};
export var useCheckBoxError = function (field) {
    var form = useForm();
    var checkBoxError = useMemo(function () { return Boolean(form.touched[field] && form.errors[field]); }, [form, field]);
    return checkBoxError;
};
export var useFileError = function (field) {
    var form = useForm();
    var fieldError = useMemo(function () {
        return form.touched[field] ? form.errors[field] : null;
    }, [field, form]);
    return fieldError;
};
export var useUpdateOnSubmit = function (submit) {
    var onSubmitRef = useOnSubmitRef();
    useEffect(function () {
        onSubmitRef.current = submit;
    }, [submit]);
};
export var useFormIsValidAlert = function (invalidText, callback) {
    if (callback === void 0) { callback = function () { return null; }; }
    var isSubmittingRef = useRef(false);
    var form = useForm();
    var alert = useAlert();
    var invalidInfoText = useBaseI18n(function (i18n) { return i18n.error.invalidInfo; });
    useEffect(function () {
        if (form.isSubmitting)
            isSubmittingRef.current = true;
        else if (isSubmittingRef.current === true) {
            isSubmittingRef.current = false;
            if (form.isValid)
                return;
            invalidText !== null && alert(invalidText || invalidInfoText);
            callback();
        }
    }, [form === null || form === void 0 ? void 0 : form.isSubmitting]);
};
//# sourceMappingURL=form-hooks.js.map